var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import InfoCircleSvg from './info-circle.icon.svg';
export const InfoCircleIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: InfoCircleSvg }));
_react_refresh_temp_1 = InfoCircleIcon;
$RefreshReg$(_react_refresh_temp_1, "InfoCircleIcon");
